// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".last-searches .last-search[data-v-1857b6c7]{cursor:pointer;font-size:12px}.last-searches .last-search .airport[data-v-1857b6c7]{color:#1458a9;font-size:13px;font-weight:500;text-transform:uppercase}.last-searches .last-search .icon-passengers[data-v-1857b6c7]{display:inline-block;max-width:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
